export default "__VITE_ASSET__C$wnAgP9__"